import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

const isEmptyFilterValue = (value) =>
  isObject(value) ? isEmpty(value) : isNil(value);

export default isEmptyFilterValue;
